import { render, staticRenderFns } from "./OrdersMainFilter.vue?vue&type=template&id=f8e31df8"
import script from "./OrdersMainFilter.vue?vue&type=script&lang=js"
export * from "./OrdersMainFilter.vue?vue&type=script&lang=js"
import style0 from "./OrdersMainFilter.vue?vue&type=style&index=0&id=f8e31df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports